// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__3ah2e","badge":"styles_badge__2EOYG"};